import { defineMessages } from 'react-intl';

const translations = {
  title: {
    id: 'pages.fulfilmentLocations.createFulfilmentLocationDrawer.title',
    defaultMessage: 'Create fulfilment location',
    description: 'title of the create fulfilment location drawer',
  },
  feedback: {
    fulfilmentLocationCreated: {
      id:
        'pages.fulfilmentLocations.createFulfilmentLocationDrawer.feedback.fulfilmentLocationCreated',
      defaultMessage: 'Fulfilment location was created',
      description: 'feedback message when the location was created',
    },
    fulfilmentLocationNotCreated: {
      id:
        'pages.fulfilmentLocations.createFulfilmentLocationDrawer.feedback.fulfilmentLocationNotCreated',
      defaultMessage: 'Could not create fulfilment location',
      description: 'feedback message when the location could not be created',
    },
  },
};

export default defineMessages(translations);
